let Settings = {
  env:             'production',
  backendEnv:   'http://localhost:8080',
  useServiceStubs: true,
  useApiGateway:   true,
  oauth: {
    Scope: "profile+" +
          "email+" +
          "https://www.googleapis.com/auth/admin.directory.user.readonly+" +
          "https://www.googleapis.com/auth/directory.user.readonly+" +
          "https://www.googleapis.com/auth/admin.directory.group.readonly",
    prompt: "select_account",
    state: "to_google",
    includeGrantedScopes : true,
    client_id : '718520354994-pd8k1m1de6bbtbrh8jpaulp2um3470td.apps.googleusercontent.com',
    endpointUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
    responseType : "code",
    accessType: "online",
    userUrl: "https://www.googleapis.com/oauth2/v3"
  },
  token: {grantType: "authorization_code",client_secret: 'Gpo8Rib9ujsk_ByuzFAtU4Kx'}
};

if (!window.location.origin) { // For IE Compatibility
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
}

let origin = window.location.origin.toLowerCase();
let host = window.location.hostname.toLowerCase();
let port = window.location.port;

Settings.oauth.redirectUrl = origin+ "/teacher/index.html";

// let origin = window.location.origin.toLowerCase();
// let host = window.location.hostname.toLowerCase();
// let port = window.location.port;

// Settings.oauth.redirectUrl = `${origin}/subscribe/index.html${Settings.oauth.code.redirectUrl}`;
// Settings.oauth.token.redirectUrl = `${origin}/subscribe/index.html${Settings.oauth.token.redirectUrl}`;

if (host === 'localhost' || host === '127.0.0.1') {
  if (port === '9876') { // Port used for running unit tests
    Settings.env             = 'test';
    Settings.useServiceStubs = false;
    Settings.useApiGateway   = false;
  } else {
    Settings.env             = 'development';
    Settings.useServiceStubs = false;
    Settings.useApiGateway   = false;
  }

} else if (host.match(/classbrick/)) {
  Settings.env = 'signoff';
  Settings.backendEnv = "http://ec2-54-152-44-110.compute-1.amazonaws.com:8080";
}

export default Settings;




/** WEBPACK FOOTER **
 ** ./src/olr-common/Settings.js
 **/